<div class="notification-bell" routerLink="/notifications">
  <div class="notification-bell__box">
    <mat-icon [svgIcon]="svgIconName.BELL" class="notification-bell__icon"></mat-icon>
    <div [ngClass]="{ 'notification-bell__counter--active': (count | async) > 0 }"
         class="notification-bell__counter">
      {{count | async | numberMax}}
    </div>
  </div>
</div>
